import { render, staticRenderFns } from "./commissioned.vue?vue&type=template&id=351ef6d2&scoped=true"
import script from "./commissioned.vue?vue&type=script&lang=js"
export * from "./commissioned.vue?vue&type=script&lang=js"
import style0 from "./commissioned.vue?vue&type=style&index=0&id=351ef6d2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "351ef6d2",
  null
  
)

export default component.exports